import { Container } from "react-bootstrap";
import Menu from "../sections/Menu";
import Footer from "../sections/Footer";
import PageMeta from "../seo/PageMeta";
import KalkulatorROI from "../components/KalkulatorROI";

function KalkulatorOszczednosci() {
  return (
    <>
      <PageMeta path="/kalkulator-oszczednosci" />
      <Menu />

      <Container style={{ paddingTop: "100px", minHeight: "70vh", marginBottom: "60px" }}>
        <div className="text-center">
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              color: "#1f2937",
              marginBottom: "4px",
            }}
          >
            <span style={{ color: "#407EF9" }}>Kalkulator oszczędności</span>
          </h1>
        </div>

        <KalkulatorROI />
      </Container>

      <Footer />
    </>
  );
}

export default KalkulatorOszczednosci;
